import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogoService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  getProductos(token: String, idTienda: number) {
    const url = this.config.urlService + "api/Catalogo/General/" + idTienda;
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    return this.http.get(url, requestOptions);
  }


  getProductosTienda(token: String, idTienda: number) {
    const url = this.config.urlService + "api/Catalogo/Tienda/" + idTienda;
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    return this.http.get(url, requestOptions);
  }

  getProductoInventarioTienda(token: String, idTienda: number, idProducto: number) {
    const url = this.config.urlService + "api/Catalogo/Tienda/Inventario/" + idTienda + "/" + idProducto;
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    return this.http.get(url, requestOptions);
  }

  // información de productos en general
  getProductosProveedor(token: String) {
    const url = this.config.urlService + "api/Catalogo";
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    return this.http.get(url, requestOptions);
  }

}
